import { useEffect, useState } from "react";
import { Plus, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/admin/common";
import { CardsTable } from "@/components/admin/CardsTable";
import { NewCardDialog } from "@/components/admin/NewCardDialog";
import { api } from "@/lib/api";

const FILTERS = [["", "Attive"], ["published", "Pubblicate"], ["draft", "Bozze"], ["disabled", "Disattivate"], ["archived", "Archiviate"]];

export default function Cards() {
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [cards, setCards] = useState([]);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/cards", { params: { q, status } }).then((r) => setCards(r.data));
  useEffect(() => {
    const h = setTimeout(load, 200);
    return () => clearTimeout(h);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, status]);
  return (
    <div>
      <PageHeader eyebrow="Biglietti digitali" title="Card" description="Tutte le card dei tuoi clienti: modifica, pubblica, scarica il QR.">
        <Button onClick={() => setOpen(true)} data-testid="create-card-button"><Plus className="mr-1.5 h-4 w-4" />Nuova card</Button>
      </PageHeader>
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-center">
        <div className="relative flex-1"><Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400" /><Input data-testid="card-search-input" placeholder="Cerca card, cliente o indirizzo" value={q} onChange={(e) => setQ(e.target.value)} className="h-10 bg-white pl-9" /></div>
        <div className="flex flex-wrap rounded-lg border bg-white p-1">
          {FILTERS.map(([k, l]) => <button key={k || "active"} data-testid={`card-filter-${k || "active"}`} onClick={() => setStatus(k)} className={`rounded-md px-3 py-1.5 text-xs ${status === k ? "bg-zinc-900 text-white" : "text-zinc-600 hover:bg-zinc-100"}`}>{l}</button>)}
        </div>
      </div>
      <CardsTable cards={cards} onChanged={load} />
      <NewCardDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
